import React, { Component } from "react";
import apcApi from "../../../api/apcApi";
import Wait from "@react/react-spectrum/Wait";

// Stage/prod serve this app proxied under a /channelpartners path (Community
// proxy); the portal link needs that path appended there. Other environments
// (dev/qa/local) serve the app directly at their own origin, so they're left
// untouched. Evaluated fresh on every render (not cached) so a stale stored
// origin can never leave this link permanently wrong for the session.
const CHANNEL_PARTNERS_ORIGINS = [
  "https://partners.stage.adobe.com",
  "https://partners.adobe.com",
];

function getContactUrlOrigin() {
  const storedOrigin = sessionStorage.getItem("contactUrlOrigin");
  if (!storedOrigin) {
    return "#";
  }
  return CHANNEL_PARTNERS_ORIGINS.includes(storedOrigin)
    ? `${storedOrigin}/channelpartners/`
    : storedOrigin;
}

class ApprovedContact extends Component {
  constructor() {
    super();
  }

  state = {
    isLoading: true,
    apiStatusCode: "",
    apiStatus: "",
  };

  componentDidMount() {
    apcApi
      .post(
        "v1/APC/acceptinvite",
        {},
        {
          headers: {
            "Cache-Control": "no-cache",
            Authorization:
              "Bearer " + window?.adobeIMS?.getAccessToken()?.token,
            "x-api-key": "exchange_spr",
          },
        }
      )
      .then((res) => {
        this.setState({
          apiStatusCode: res?.status?.toString(),
          apiStatus: "success",
          isLoading: false,
        });
      })
      .catch((err) => {
        if (err.response) {
          // Server responded with a status code outside 2xx
          this.setState({
            apiStatusCode: err?.response?.status?.toString(),
            apiStatus: "failed",
            isLoading: false,
          });
        }
      });
  }

  render() {
    const contactUrlOrigin = getContactUrlOrigin();
    const { isLoading, apiStatus, apiStatusCode } = this.state;

    return (
      <div>
        {isLoading && <Wait size="L" centered />}

        {!isLoading && apiStatus === "success" && (
          <div style={{ padding: "0px 25px" }}>
            <h2>Contact Approved</h2>
            <p>
              You now have access to the{" "}
              <a
                href={contactUrlOrigin}
                target="_blank"
                style={{ color: "#8cd2f5", textDecoration: "none" }}
              >
                Adobe Partner Connection Portal
              </a>
            </p>
          </div>
        )}

        {!isLoading && apiStatus === "failed" && apiStatusCode === "401" && (
          <div style={{ padding: "0px 25px" }}>
            <h2>Contact Not Approved</h2>
            <p>Sorry, you are not authorized to perform this action.</p>
          </div>
        )}

        {!isLoading && apiStatus === "failed" && apiStatusCode !== "401" && (
          <div style={{ padding: "0px 25px" }}>
            <h2>Contact Not Approved</h2>
            <p>
              Something went wrong. Please try again later, or contact support
              if the problem continues.
            </p>
          </div>
        )}
      </div>
    );
  }
}

export default ApprovedContact;
